import angular from "angular";

angular
	.module('app')
	.component('messageMoreDetails', {
		template: require('./message-more-details.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });
            
function controller() {
        
	let $ctrl = this;

    $ctrl.message = null;

	$ctrl.$onInit = function () {
        $ctrl.message = $ctrl.resolve.message;
        console.log($ctrl.message.phone)
    };
}